import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DAYS_AHEAD = 14;

const to12h = (t) => {
  const [h, m] = t.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${ap}`;
};

export const SlotPicker = ({ value, onChange }) => {
  const [dates] = useState(() =>
    Array.from({ length: DAYS_AHEAD }, (_, i) => {
      const d = new Date();
      d.setDate(d.getDate() + i);
      const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
      return { iso, wd: d.toLocaleDateString("en-US", { weekday: "short" }).toUpperCase(), dd: String(d.getDate()).padStart(2, "0") };
    })
  );
  const [date, setDate] = useState(dates[0].iso);
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${API}/slots`, { params: { date } });
        setSlots(data.slots);
      } catch {
        setSlots([]);
        toast.error("Slots load nahi ho paye. Dobara try karein.");
      } finally {
        setLoading(false);
      }
    })();
  }, [date]);

  return (
    <div data-testid="slot-picker">
      <label className="font-mono text-[10px] tracking-[0.25em] uppercase text-neutral-500 block mb-2">Date</label>
      <div className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1">
        {dates.map((d) => (
          <button
            key={d.iso}
            data-testid={`slot-date-${d.iso}`}
            onClick={() => setDate(d.iso)}
            className={`shrink-0 border rounded-lg px-3 py-2.5 font-mono text-[10px] tracking-wider transition-colors ${
              date === d.iso ? "border-gold text-gold bg-gold/10" : "border-white/15 text-neutral-400 hover:border-white/40"
            }`}
          >
            <span className="block">{d.wd}</span>
            <span className="block text-sm font-bold mt-0.5">{d.dd}</span>
          </button>
        ))}
      </div>
      <label className="font-mono text-[10px] tracking-[0.25em] uppercase text-neutral-500 block mt-4 mb-2">Time (IST)</label>
      {loading ? (
        <div className="flex items-center gap-3 py-6 justify-center text-neutral-500">
          <Loader2 size={16} className="animate-spin" />
          <span className="font-mono text-[10px] tracking-widest uppercase">Loading slots...</span>
        </div>
      ) : slots.length === 0 ? (
        <p className="py-4 text-center font-mono text-[10px] tracking-widest uppercase text-neutral-500 border border-dashed border-white/15 rounded-lg">
          Is din slots available nahi — doosri date try karein
        </p>
      ) : (
        <div className="grid grid-cols-3 gap-2">
          {slots.map((s) => {
            const selected = value === `${date}T${s.time}`;
            return (
              <button
                key={s.time}
                data-testid={`slot-time-${s.time}`}
                disabled={!s.available}
                onClick={() => onChange(`${date}T${s.time}`)}
                className={`border rounded-lg px-2 py-3 font-mono text-xs tracking-wider transition-colors ${
                  selected
                    ? "border-gold text-gold bg-gold/10"
                    : s.available
                      ? "border-white/15 text-neutral-300 hover:border-gold/60 hover:text-gold"
                      : "border-white/5 text-neutral-600 line-through cursor-not-allowed"
                }`}
              >
                {to12h(s.time)}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};